import BackButton from '../generic/BackButton'
import { Wrapper } from '../generic/Layout'
import useTranslation from '../../hooks/useTranslation'
import { resolveVisibility } from "../../../../common/model/condition/evaluate"
import RSwitcher from '../generic/RSwitcher'
import styled from 'styled-components'

import { Button } from '../generic/Core'
import SpinnerButton from '../generic/SpinnerButton'
import IconButton from '../generic/IconButton'
import DisplayElement from '../display/DisplayElement'
import RButton from '../generic/RButton'
import resolve from '../../../../common/utils/object/resolve'

const ButtonGroup = styled.div`
    display: flex;
`

import { useStore } from '../pageView/Page'
import { useQueryClient } from "@tanstack/react-query"

// `busy`: an action is running — its buttons wait (useFormActions).
const CardViewTitle = ({ options, config, handleActions, busy = false }) => {
    const [state] = useStore((s) => s)
    const { t, m } = useTranslation()
    const queryClient = useQueryClient()

    // The heading is one `titleBar` object in every map that has one. There is
    // no flat-key fallback: `titleField` and `newTitle` are gone.
    const bar = config.titleBar ?? {}

    // `label` is optional. With one, the title is a translated template —
    // 'invoice.form.title' = "Invoice ${1}" — which keeps word order a
    // translator's decision. Without one, the first param renders on its own,
    // which is what every card did before `titleBar` existed.
    const heading = options.mode === 'new'
        ? t(bar.new)
        : bar.label
            ? m(bar.label, (bar.mergeParams ?? []).map(f => resolve(f, state) ?? ''))
            : <DisplayElement string={resolve(bar.mergeParams?.[0], state)} type={bar.type} />

    //The Option array passed to switcher expects: type, id and name.
    let menuOptions

if (config.cardTitle?.menuItems) {
  menuOptions = config.cardTitle.menuItems
    .filter(item => {
      if (!item.dependency) return true
      const held = state?.[item.dependency.id] ?? false
      // A list: offered in any of those states.
      return Array.isArray(item.dependency.value)
        ? item.dependency.value.includes(held)
        : held === item.dependency.value
    })
    .map(item => ({
      type: 'item',
      id: item.action,
      name: t(item.label),
      ...item
    }));
}

    const handleSubmit = async (button) => {
        const action = button.action ?? 'save'
        const confirm = button.confirm ?? false
        const modalConfig = button.modalConfig ?? ''
        const invalidateQuery = button.invalidateQuery ?? null

        const option = { action, confirm, modalConfig, invalidateQuery }
        await handleActions(option)
    }

    return (
        <Wrapper $width={config.width || config.cardTitle?.width || ''}>
            <h2>
                {config.showBack !== false && <BackButton config={config} />}
                <span>{heading}</span>
            </h2>
            <ButtonGroup>
                {//Getting Buttons from the config
                    config.cardTitle?.buttons && config.cardTitle.buttons.map(
                        (button, k) => {
                            // A button's condition may test the mode (`$mode`) or a field of
                            // the record — Studio's Rollback hides on the version already live.
                            const show = resolveVisibility(button, { values: state ?? {}, context: { mode: options?.mode } }) === 'show';
                            if (!show) return null; // skip rendering this button
                            
                            //Note Submit Button sends the form and it is a special case.
                            return (
                                (button.type === 'submit')
                                    ? <RButton $shadow name='submit' $variant={button.variant}
                                        key={`btn-${k}`} type={button.type}
                                        onClick={e => handleSubmit(button)}
                                        disabled={busy}
                                        testId={`${config.entity}.title.${button.action}`}
                                        icon={button.icon} label={button.label}
                                    >
                                        {t(button.label)}
                                    </RButton>
                                    : (button.size === 'icon') ? <IconButton
                                        icon={button.icon} $variant={button.variant} $marginRight={'0.5rem'} $size='2.5rem' clickAction={(e) => {
                                            if (!busy) handleActions(button)
                                        }}
                                    />
                                        : <RButton $shadow={true} $variant={button.variant} key={`btn-${k}`} type={button.type}
                                            name={button.action} icon={button.icon} label={button.label} $marginRight={'0.5rem'}
                                            disabled={busy}
                                            onClick={(e) => {
                                                handleActions(button)
                                            }}>
                                            {t(button.label)}
                                        </RButton>
                            )
                        }
                    )
                }
                {options.mode === 'new' ? <></> :
                    menuOptions && <RSwitcher currentOption={t(config.cardTitle.title)} options={menuOptions} handleSelect={(option) => { if (!busy) handleActions(option) }} type={config.entity} disabled={busy}
                    />
                }
            </ButtonGroup>
        </Wrapper>

    )
}

export default CardViewTitle
